import { IMAGE_BASE_URL } from "./utility";

/**
 * Build a profile/logo image URL with optional cache-busting.
 */
export const buildProfileImageSrc = (profileImagePath, cacheVersion) => {
  if (!profileImagePath) {
    return "";
  }

  if (
    profileImagePath.startsWith("blob:") ||
    profileImagePath.startsWith("data:") ||
    profileImagePath.startsWith("http")
  ) {
    return profileImagePath;
  }

  const normalizedPath = profileImagePath.replace(/^\//, "");
  const url = `${IMAGE_BASE_URL}${normalizedPath}`;
  return cacheVersion ? `${url}?v=${cacheVersion}` : url;
};

/**
 * Build 1–2 letter initials from a display name, falling back to email.
 */
export const getDisplayInitials = (name = "", email = "") => {
  const fromName = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase();

  if (fromName) {
    return fromName;
  }

  const localPart = String(email || "")
    .trim()
    .split("@")[0];

  if (localPart) {
    return localPart.charAt(0).toUpperCase();
  }

  return "";
};

/**
 * Parse user/edit API payload — handles nested ResponseBuilder shapes.
 */
export const parseProfileUpdateResponse = (responseBody) => {
  const payload = responseBody?.data;
  const jwtClaims = payload?.user ?? payload?.data?.user ?? null;
  const user = jwtClaims?.user ?? null;

  return { jwtClaims, user };
};

/**
 * Build FormData for profile update (skip empty file / null crop fields).
 */
export const buildProfileUpdateFormData = (data) => {
  const formData = new FormData();
  const skipKeys = new Set(["profile_image", "cropped_image"]);

  Object.keys(data || {}).forEach((key) => {
    if (skipKeys.has(key)) {
      return;
    }

    const value = data[key];
    if (value !== undefined && value !== null && value !== "") {
      formData.append(key, value);
    }
  });

  if (data?.remove_profile_image) {
    formData.append("remove_profile_image", data.remove_profile_image);
  }

  if (data?.profile_image instanceof File) {
    formData.append("profile_image", data.profile_image);
  }

  if (data?.cropped_image) {
    formData.append("cropped_image", data.cropped_image);
  }

  return formData;
};
